import { ArrowUpRight } from "lucide-react";

const ACCOM_URL =
  'https://booking-directly.com/widgets/ngmq4BR7J3jnOzKJvE1KewObzdQRrgXShuY5bm7WvGlAns7kyEddCqsSQ0UfZ/properties/unit-selection?search_stay_dates={%22checkInDate%22:%222026-05-29%22,%22checkOutDate%22:%222026-05-30%22}&search_occupancies=[{%22numberOfAdults%22:2,%22children%22:[]}]';

const ROOMS = [
  {
    title: "Double Ensuite Room",
    desc: "King-size bed with crisp linens, Gower seascape artwork, and warm bedside lighting.",
    image:
      "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/f1o0ir5b_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_00_33%20PM.png",
    tall: true,
  },
  {
    title: "Comfort Double Room",
    desc: "Quiet ensuite double with dressing table, armchair seating, and tea/coffee station.",
    image:
      "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/rvb882jr_ChatGPT%20Image%20May%2029%2C%202026%2C%2009_59_29%20PM.png",
  },
  {
    title: "Standard Double Ensuite",
    desc: "Restful overnight room with fresh towels and a Gower coastline canvas above the bed.",
    image:
      "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/xk9wlfxp_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_16_45%20PM.png",
  },
];

export default function Hospitality() {
  return (
    <section
      id="accommodation"
      data-testid="hospitality-section"
      className="bg-[#FAFAFA] py-24 md:py-32 lg:py-40 border-y border-[#CBA153]/15"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-8">
            <span className="section-eyebrow">04 · On-Site Accommodation</span>
            <h2 className="font-serif-luxury text-4xl md:text-5xl lg:text-6xl text-[#0F4C3A] mt-5 leading-[1.05] tracking-tight">
              11 double ensuite rooms,
              <span className="block italic text-gold-metallic">on the Gower Peninsula.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-[#4A4A4A] leading-relaxed">
              Comfortable, no-fuss overnight accommodation in the heart of the Gower Peninsula.
              Whether you're visiting for golf, a coastal getaway, a wedding, or to explore Gower's stunning beaches
              and countryside, our eleven double ensuite bedrooms provide a convenient and comfortable place to stay.
            </p>
          </div>
        </div>

                        
<div className="mb-10 bg-[#0F4C3A] border border-[#CBA153]/50 px-8 py-8 md:py-10 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8 text-center">
  <span className="text-[#E5C15D] text-xs md:text-sm font-semibold tracking-[0.3em] uppercase">
    Winter 2026–27
  </span>

  <span className="hidden md:block text-[#CBA153] text-2xl">·</span>

  <span className="font-serif-luxury text-3xl md:text-4xl lg:text-5xl text-white leading-none">
    Dinner, Bed & Breakfast
  </span>

  <div className="flex flex-col items-center gap-2">
    <span className="text-[#E5C15D] text-3xl md:text-4xl lg:text-5xl font-bold leading-none">
      £120.00 <span className="text-2xl md:text-3xl font-medium">per night</span>
    </span>
    <span className="text-[#E5C15D] text-xs md:text-sm font-medium tracking-wide">
      Per room · Based on two guests sharing
    </span>
  </div>
</div>

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
  {ROOMS.map((r, i) => (
    <article
      key={r.title}
      data-testid={`room-card-${i}`}
      className="group image-frame bg-white border border-[#CBA153]/25 hover-lift"
    >
      <div className="relative overflow-hidden h-[360px] lg:h-[440px]">
        <img src={r.image} alt={r.title} className="w-full h-full object-cover" />
      </div>
      <div className="p-6">
        <p className="section-eyebrow text-[10px]">On-Site Stay</p>
        <h3 className="font-serif-luxury text-xl md:text-2xl text-[#0F4C3A] mt-2">
          {r.title}
        </h3>
        <p className="text-sm text-[#4A4A4A] mt-2 leading-relaxed">
          {r.desc}
        </p>
        <div className="gold-rule mt-4" />
      </div>
    </article>
  ))}
</div>

        <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-6 bg-white border border-[#CBA153]/30 px-8 py-7">
          <div>
            <p className="section-eyebrow">Direct Reservations</p>
            <h4 className="font-serif-luxury text-2xl md:text-3xl text-[#0F4C3A] mt-2">
              11 ensuite double rooms · Book your overnight stay.
            </h4>
          </div>
          <a
            data-testid="book-accommodation-btn"
            href={ACCOM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ggc-btn-solid-gold whitespace-nowrap"
          >
            Book Accommodation Online
            <ArrowUpRight size={16} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </section>
  );
}
